import React from "react";
import {
  AppRouter, 
  AllegroHeader,
  AllegroSideMenu,
} from "./shared";
import AppLayout from "@amzn/meridian/app-layout";
import MainContent from "./routes/mainContent";

const AppContent = () => {
  return (
    <AppLayout
      headerComponent={AllegroHeader}
      sidebarComponent={AllegroSideMenu}
    >
      <AllegroHeader></AllegroHeader>
      <AllegroSideMenu></AllegroSideMenu>
      <MainContent></MainContent>
    </AppLayout>
  );
};

export default AppContent;
